import { baseApi, BASE_API_URL } from './baseApi';

// Add endpoints object for consistent access across the app
export const endpoints = {
  users: (userId) => `/users/${userId}`,
  autopilotSettings: (userId) => `/users/${userId}/autopilot-settings`,
  manageSubscription: () => `/subscription/manage`,
};

export const userApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    updateUserById: builder.mutation({
      query: ({ userId, userData }) => ({
        baseUrl: BASE_API_URL,
        url: endpoints.users(userId),
        method: "PUT",
        body: JSON.stringify(userData),
      }),
    }),

    updateAutopilotSettings: builder.mutation({
      query: ({ userId, userData }) => ({
        baseUrl: BASE_API_URL,
        url: endpoints.autopilotSettings(userId),
        method: "PUT",
        body: JSON.stringify(userData),
      }),
    }),

    getUserById: builder.query({
      query: (userId) => ({
        baseUrl: BASE_API_URL,
        url: endpoints.users(userId),
        method: "GET",
      }),
    }),
    
    manageSubscription: builder.mutation({
      query: ({ userId, subscriptionData }) => ({
        baseUrl: BASE_API_URL,
        url: endpoints.manageSubscription(),
        method: "POST",
        body: JSON.stringify(subscriptionData),
        headers: {
          "User-Identifier": userId,
          "Content-Type": "application/json"
        }
      }),
    }),
  }),
});

export const {
  useUpdateUserByIdMutation,
  useUpdateAutopilotSettingsMutation,
  useGetUserByIdQuery,
  useManageSubscriptionMutation,
} = userApi; 